export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.054 7.17a1.273 1.273 0 0 1 1.893 0l7.843 8.715a.818.818 0 0 1-1.216 1.095L12 8.565 4.426 16.98a.818.818 0 1 1-1.216-1.095l7.844-8.715Z"/>
</svg>
`;
